import { createContext } from 'react';
import { UsuarioProps } from '../../shared/types/usuarioProps';

export type AuthContextType = {
  currentUser: UsuarioProps | null;
  validateToken: () => void;
  signIn: (login: string, senha: string) => Promise<boolean>;
  logout: () => void;
  showLoading: boolean;
  setShowLoading: (state: boolean) => void;
  loginError: string | null;
};

export const AuthContext = createContext<AuthContextType>(null!);
